import Map from "ol/Map";

/** 앱 레벨에서 map.setProperties()로 관리하는 상태 키 */
interface MapAppState {
  /** 드로잉 툴이 활성화되어 있는지 여부 */
  isDrawing?: boolean;
  /** 어노테이션 수정 모드가 활성화되어 있는지 여부 */
  isModifying?: boolean;
}

/**
 * map.getProperties()를 타입 안전하게 읽습니다.
 */
export function getMapAppState(map: Map): MapAppState {
  const props = map.getProperties();
  return {
    isDrawing: props["isDrawing"] === true,
    isModifying: props["isModifying"] === true,
  };
}

/**
 * map.setProperties()를 기존 상태와 merge하여 타입 안전하게 씁니다.
 */
export function setMapAppState(map: Map, state: Partial<MapAppState>): void {
  const existing = map.getProperties();
  map.setProperties({ ...existing, ...state });
}
